import { useRoutes } from 'react-router-dom';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import PublicPaymentRoutes from './PublicPaymentRoutes ';

export default function ThemeRoutes() {
  return useRoutes([LoginRoutes, PublicPaymentRoutes, MainRoutes]);
}
